import React, { useCallback } from 'react';
import { transitStatusFilterStyles } from './styled';
import { SegmentedButton } from '@ontruck/orc';

export const options = {
  pre_transit: { value: 'pre_transit', label: 'Pre transit' },
  in_transit: { value: 'in_transit', label: 'In transit' },
  post_transit: { value: 'post_transit', label: 'Post transit' },
};

const renderLabel = (count) => {
  if (!count) return '';
  return `(${count})`;
};

const TransitStatusFilter = ({ className, value, onChange, counters }) => {
  const handleChange = useCallback(
    (_, { value: selectedValue }) => {
      onChange(selectedValue);
    },
    [onChange]
  );

  const handleClick = useCallback(
    (optionValue) => () => {
      if (optionValue === value) {
        onChange(null);
      }
    },
    [value, onChange]
  );

  return (
    <div className={className}>
      <SegmentedButton.Parent value={value} onChange={handleChange}>
        <SegmentedButton.Child
          onClick={handleClick(options.pre_transit.value)}
          value={options.pre_transit.value}
          label={`${options.pre_transit.label}${renderLabel(counters?.pre_transit)}`}
        />
        <SegmentedButton.Child
          onClick={handleClick(options.in_transit.value)}
          value={options.in_transit.value}
          label={`${options.in_transit.label}${renderLabel(counters?.in_transit)}`}
        />

        <SegmentedButton.Child
          onClick={handleClick(options.post_transit.value)}
          value={options.post_transit.value}
          label={`${options.post_transit.label}${renderLabel(counters?.post_transit)}`}
        />
      </SegmentedButton.Parent>
    </div>
  );
};

TransitStatusFilter.filterName = 'TransitStatusFilter';

export default transitStatusFilterStyles(TransitStatusFilter);
